import React, { FC } from 'react';
import CustomAccordion from '../../../common/components/CustomAccordion/CustomAccordion';
import BusinessEditExpert from '../DetailItem/BusinessEditExpert';
import BusinessEditGestionnaire from '../DetailItem/BusinessEditGestionaire';
import { Grid } from '@material-ui/core';

interface Props {}

export const BusinessConnectCreditReferency: FC<Props> = (props) => {
  const {} = props;
  return (
    <CustomAccordion title="Référents Connectcrédit">
      <Grid container>
        <BusinessEditExpert />
        <BusinessEditGestionnaire />
      </Grid>
    </CustomAccordion>
  );
};
